import React from 'react';
import {LargeTagC} from './styles';

export default ({text, color = '#007AFF'}: {text: string; color?: string}) => <LargeTagC color={color}>{text}</LargeTagC>;
